export const firstNonZeroValueFrom = <T>(
  array: T[],
  startIndex = 0,
  key?: keyof T
): T | undefined => {
  for (let i = startIndex; i < array.length; i++) {
    if (key ? array[i]?.[key] : array[i]) {
      return array[i];
    }
  }

  return undefined;
};
